import { callApi } from "@/api/api-core";

export const searchTrips = function(
    tripType,
    startLocation,
    endLocation,
    instant,
    searchType,
    ownerHandlesFailure
) {
    const data = { tripType, startLocation, endLocation, instant, searchType };

    return callApi("POST", "v3/trips/search", data, ownerHandlesFailure);
};
